import {
  FETCH_DAO_LIST_REQUEST,
  FETCH_DAO_LIST_SUCCESS,
  FETCH_DAO_LIST_FAILURE,
  FETCH_DAO_DETAIL_REQUEST,
  FETCH_DAO_DETAIL_SUCCESS,
  FETCH_DAO_DETAIL_FAILURE,
  FETCH_DAO_MEMBERS_REQUEST,
  FETCH_DAO_MEMBERS_SUCCESS,
  FETCH_DAO_MEMBERS_FAILURE,
  FETCH_DAO_VOTING_HISTORY_REQUEST,
  FETCH_DAO_VOTING_HISTORY_SUCCESS,
  FETCH_DAO_VOTING_HISTORY_FAILURE,
  FETCH_DAO_LICENSE_REQUEST,
  FETCH_DAO_LICENSE_SUCCESS,
  FETCH_DAO_LICENSE_FAILURE,
  FETCH_DAO_CODEBASES_REQUEST,
  FETCH_DAO_CODEBASES_SUCCESS,
  FETCH_DAO_CODEBASES_FAILURE,
} from '../../views/pages/app/dao/actions';

const defaultState = {
  daoList: [],
  currentDao: null,
  daoMembers: [],
  daoVotingHistory: [],
  license: null,
  daoCodebases: [],
  loading: false,
  error: null,
};

export default (state = defaultState, action) => {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case FETCH_DAO_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DAO_LIST_SUCCESS:
      return { ...state, loading: false, daoList: action.payload };
    case FETCH_DAO_LIST_FAILURE:
      return { ...state, loading: false, error: action.error };

    case FETCH_DAO_DETAIL_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DAO_DETAIL_SUCCESS:
      return { ...state, loading: false, currentDao: action.payload };
    case FETCH_DAO_DETAIL_FAILURE:
      return { ...state, loading: false, error: action.error };

    case FETCH_DAO_MEMBERS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DAO_MEMBERS_SUCCESS:
      return { ...state, loading: false, daoMembers: action.payload };
    case FETCH_DAO_MEMBERS_FAILURE:
      return { ...state, loading: false, error: action.error };

    case FETCH_DAO_VOTING_HISTORY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DAO_VOTING_HISTORY_SUCCESS:
      return { ...state, loading: false, daoVotingHistory: action.payload };
    case FETCH_DAO_VOTING_HISTORY_FAILURE:
      return { ...state, loading: false, error: action.error };

    case FETCH_DAO_LICENSE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DAO_LICENSE_SUCCESS:
      return { ...state, loading: false, license: action.payload };
    case FETCH_DAO_LICENSE_FAILURE:
      return { ...state, loading: false, error: action.error };

    case FETCH_DAO_CODEBASES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DAO_CODEBASES_SUCCESS:
      return { ...state, loading: false, daoCodebases: action.payload };
    case FETCH_DAO_CODEBASES_FAILURE:
      return { ...state, loading: false, error: action.error };

    default:
      return nextState;
  }
};
